module.exports = __webpack_public_path__ + "assets/6f9af4a07f69e45ff06fcefd9a7066d9.mp3";